module.exports = __webpack_public_path__ + "img/cssicon.d0918168.png";